<template>
  <div class="travel-schedule">
    <div
      v-for="(daySchedule, dayIndex) in schedule"
      :key="dayIndex"
      class="day-schedule"
    >
      <div class="day-header">
        <span class="day-number"
          >{{ $t("theDay") }} {{ dayIndex + 1
          }}{{ $i18n.locale === "zh" ? $t("day") : "" }}</span
        >
        <el-button
          icon="el-icon-delete"
          type="text"
          @click="removeDay(dayIndex)"
        >
          {{ $t("deleteDay") }}
        </el-button>
      </div>
      <div
        v-for="(spot, spotIndex) in daySchedule.spots"
        :key="spotIndex"
        class="spot-row"
      >
        <el-time-select
          v-model="spot.time"
          :placeholder="$t('selectTime')"
          start="08:00"
          end="20:00"
          step="00:30"
          class="time-select"
        />
        <div class="rich-editor-container">
          <quill-editor
            v-model="spot.content"
            :ref="`editor-${dayIndex}-${spotIndex}`"
            :options="editorOptions"
            class="spot-rich-editor"
            @ready="onEditorReady(dayIndex, spotIndex)"
            :key="$i18n.locale"
          />
        </div>
        <el-button
          :icon="spotIndex === 0 ? 'el-icon-plus' : 'el-icon-delete'"
          type="text"
          @click="
            spotIndex === 0
              ? addSpot(dayIndex)
              : removeSpot(dayIndex, spotIndex)
          "
        >
          {{ spotIndex === 0 ? $t("addSpot") : $t("delete") }}
        </el-button>
      </div>
    </div>
    <div class="add-day-btn" @click="addDay">+ {{ $t("addDay") }}</div>
  </div>
</template>

<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import { quillEditor } from "vue-quill-editor";
export default {
  name: "TravelSchedule",
  components: { quillEditor },
  props: {
    value: {
      type: Array,
      default: () => [
        {
          spots: [
            {
              time: "",
              content: "", // 富文本默认内容
            },
          ],
        },
      ],
    },
  },
  computed: {
    schedule: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },

    //移到 computed，语言切换自动更新
    editorOptions() {
      return {
        theme: "snow",
        modules: {
          toolbar: {
            container: [
              ["bold", "italic", "underline", "strike"], // 基础格式
              [{ list: "ordered" }, { list: "bullet" }], // 列表
              [{ align: [] }], // 对齐方式
              ["image"], // 图片上传
              ["clean"], // 清除格式
            ],
            handlers: {
              image: (value) => {
                if (value) {
                  // 暂存当前点击的编辑器索引（后面会通过 ready 事件赋值）
                  this.currentEditor = { dayIndex: null, spotIndex: null };
                  this.handleImageUpload();
                }
              },
            },
          },
        },
        placeholder: this.$t("editorPlaceholder"), // 🔥 现在会自动切换语言了！
      };
    },
  },
  data() {
    return {
      // 🔥 data 里删掉 editorOptions，只保留其他变量
      currentEditor: null,
      isUploadingImage: false,
    };
  },
  mounted() {},
  methods: {
    onEditorReady(dayIndex, spotIndex) {
      const refKey = `editor-${dayIndex}-${spotIndex}`;
      const editor = this.$refs[refKey][0];
      if (editor && editor.quill) {
        // console.log(`编辑器 ${refKey} 初始化完成`, editor.quill);
        const toolbar = editor.quill.getModule("toolbar");
        // console.log(toolbar, "toolbar");
        toolbar.container
          .querySelector(".ql-image")
          .addEventListener("click", () => {
            // this.currentEditor = { dayIndex, spotIndex };
            this.handleImageUpload(dayIndex, spotIndex);
            console.log(this.currentEditor, "currentEditor");
          });
      }
    },
    addDay() {
      this.schedule.push({
        spots: [
          {
            time: "",
            content: "",
          },
        ],
      });
      this.$emit("change");
    },
    removeDay(dayIndex) {
      if (this.schedule.length > 1) {
        this.schedule.splice(dayIndex, 1);
        this.$emit("change");
      } else {
        this.$message.warning(this.$t("keepAtLeastOneDay"));
      }
    },
    addSpot(dayIndex) {
      this.schedule[dayIndex].spots.push({
        time: "",
        content: "",
      });
      this.$emit("change");
    },
    removeSpot(dayIndex, spotIndex) {
      if (this.schedule[dayIndex].spots.length > 1) {
        this.schedule[dayIndex].spots.splice(spotIndex, 1);
      } else {
        // 保留最后一个输入框并清空内容
        this.schedule[dayIndex].spots = [
          {
            time: "",
            content: "",
          },
        ];
      }
      this.$emit("change");
    },
    handleImageUpload(dayIndex, spotIndex) {
      if (dayIndex === undefined || spotIndex === undefined) return;
      const refKey = `editor-${dayIndex}-${spotIndex}`;
      const editor = this.$refs[refKey]?.[0];
      if (!editor || !editor.quill) {
        this.$message.error(this.$t("editorNotReady"));
        return;
      }
      const input = document.createElement("input");
      input.setAttribute("type", "file");
      input.setAttribute("accept", "image/*");
      input.onchange = async (e) => {
        const file = e.target.files[0];
        if (file) {
          try {
            const imageUrl = await this.uploadImageToOSS(file);
            const quill = editor.quill; // 使用当前编辑器的 quill 实例
            const range = quill.getSelection();
            if (range) {
              quill.insertEmbed(range.index, "image", imageUrl);
              quill.setSelection(range.index + 1);
            } else {
              // 如果没有选中范围，直接追加到末尾
              quill.insertEmbed(quill.getLength() - 1, "image", imageUrl);
            }
          } catch (error) {
            console.error("插入图片失败:", error);
            this.$message.error(this.$t("insertImageFailed"));
          }
        }
      };
      input.click();
    },
    /**
     * 富文本编辑器图片上传到OSS
     * @param file
     */
    async uploadImageToOSS(file) {
      try {
        this.isUploadingImage = true; // 开始上传，设置状态
        // 创建表单数据
        const formData = new FormData();
        formData.append("file", file);
        // 发送上传请求（注意：使用return确保Promise链正确传递）
        const res = await this.$post("/rich_file_upload", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        // 检查响应状态
        console.log(res.data, "上传响应");
        if (res.data.code === 1 && res.data.data.fileUrl) {
          return res.data.data.fileUrl; // 返回URL供编辑器使用
        } else {
          throw new Error(res.data.msg || this.$t("imageUploadFailed"));
        }
      } catch (error) {
        this.$message.error(
          this.$t("imageUploadFailed") + "：" + error.message,
        );
        return Promise.reject(error);
      } finally {
        this.isUploadingImage = false; // 无论成功失败，都结束上传状态
      }
    },
  },
};
</script>
<style scoped>
.travel-schedule {
  padding: 16px 0;
}
.day-schedule {
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 16px;
  margin-bottom: 16px;
}
.day-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 1px dashed #ebeef5;
}
.day-number {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}
.spot-row {
  display: flex;
  align-items: flex-start; /* 改为顶部对齐 */
  gap: 12px;
  margin-bottom: 16px;
  padding: 8px;
  border-radius: 4px;
  transition: background-color 0.2s;
}
.spot-row:hover {
  background-color: #f5f7fa;
}
.time-select {
  width: 140px;
  margin-top: 4px; /* 微调时间选择器位置 */
}
.rich-editor-container {
  flex: 1; /* 占满剩余空间 */
}
::v-deep .spot-rich-editor .ql-container {
  border-radius: 4px;
}
::v-deep .spot-rich-editor .ql-toolbar {
  border-radius: 4px 4px 0 0;
}
::v-deep .ql-editor img {
  max-width: 100%;
  margin: 10px auto;
  display: block;
  border-radius: 4px;
}
.add-day-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dcdfe6;
  border-radius: 4px;
  height: 48px;
  font-size: 14px;
  color: #606266;
  cursor: pointer;
  transition: all 0.3s ease;
}
.add-day-btn:hover {
  border-color: #409eff;
  color: #409eff;
}
</style>
